<template>
  <div class="agreement-page">
    <div class="agreement-container">
      <div class="agreement-header">
        <h1 class="agreement-title">用户注册协议</h1>
      </div>
      <div class="agreement-content" v-html="content"></div>
      <div class="agreement-footer">
        <a-button type="primary" @click="handleBack">返回登录</a-button>
      </div>
    </div>
  </div>
</template>

<script>
import { queryByGroupAndName } from '@/api/app/config'

export default {
  name: 'UserAgreement',
  data() {
    return {
      content: '',
      loading: false,
    }
  },
  created() {
    this.loadContent()
  },
  methods: {
    async loadContent() {
      this.loading = true
      try {
        // 调用后端接口获取用户协议内容
        // configGroup: protocol, configName: userAgreement
        const response = await queryByGroupAndName({
          configGroup: 'protocol',
          configName: 'userAgreement',
        })
        if (response && response.data && response.data.configValue) {
          this.content = response.data.configValue
        } else {
          // 如果没有配置，显示默认内容
          this.content = this.getDefaultContent()
        }
      } catch (error) {
        console.error('加载用户协议失败:', error)
        // 加载失败时显示默认内容
        this.content = this.getDefaultContent()
      } finally {
        this.loading = false
      }
    },
    getDefaultContent() {
      return `
        <div class="default-content">
          <h2>用户注册协议</h2>
          <p>欢迎使用弘笃智慧云管理系统！</p>
          <p>在使用本系统之前，请您仔细阅读并同意本协议的全部内容。</p>
          <h3>一、服务条款的确认和接纳</h3>
          <p>本协议是您与弘笃智慧云管理系统之间关于使用本系统的法律协议。</p>
          <h3>二、用户账号</h3>
          <p>1. 用户在使用本系统前需要注册账号。</p>
          <p>2. 用户应当妥善保管账号和密码，不得将账号转让、出售或借给他人使用。</p>
          <h3>三、用户行为规范</h3>
          <p>用户在使用本系统时，应当遵守相关法律法规，不得从事违法违规行为。</p>
          <h3>四、隐私保护</h3>
          <p>我们将严格保护您的个人信息安全，具体内容请查看《隐私政策》。</p>
          <h3>五、免责声明</h3>
          <p>在法律允许的范围内，本系统不对因使用或无法使用本系统而产生的任何损失承担责任。</p>
          <h3>六、协议修改</h3>
          <p>我们有权随时修改本协议，修改后的协议将在系统中公布。</p>
          <p class="update-time">最后更新时间：${new Date().toLocaleDateString(
            'zh-CN'
          )}</p>
        </div>
      `
    },
    handleBack() {
      this.$router.push('/user/login')
    },
  },
}
</script>

<style lang="less" scoped>
.agreement-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 40px 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.agreement-container {
  max-width: 900px;
  width: 100%;
  background: #ffffff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  overflow: hidden;
}
.agreement-header {
  padding: 32px 40px;
  border-bottom: 1px solid #e8e8e8;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  .agreement-title {
    margin: 0;
    font-size: 28px;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }
}
.agreement-content {
  padding: 40px;
  min-height: 400px;
  line-height: 1.8;
  color: #333;
  font-size: 14px;
  /deep/ h2 {
    font-size: 24px;
    font-weight: 600;
    color: #1890ff;
    margin: 24px 0 16px 0;
  }

  /deep/ h3 {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin: 20px 0 12px 0;
  }

  /deep/ p {
    margin: 12px 0;
    color: #666;
    text-align: justify;
  }

  /deep/ .update-time {
    margin-top: 32px;
    color: #999;
    font-size: 12px;
    text-align: right;
  }

  /deep/ .default-content {
    h2 {
      text-align: center;
      margin-bottom: 24px;
    }
  }
}
.agreement-footer {
  padding: 24px 40px;
  border-top: 1px solid #e8e8e8;
  text-align: center;
  background: #fafafa;
  .ant-btn {
    min-width: 120px;
    height: 40px;
  }
}
</style>
